import { useEffect, useCallback, useState } from "react";
import { apiRequest } from "../api/apiRequest";

export const useProducts = (url) =>{

    const [data,setData]       = useState(null);
    const [loading,setLoading] = useState(null);
    const [error,setError]     = useState(null);

    // #### CONSULTA ####
    const fetchProducts = useCallback(async()=>{
        setLoading(true);
        try {                    
            const dat = await apiRequest(`${url}.json`, "GET");
            setData( (dat) ?Object.keys(dat).map(k=>({id:k,...dat[k]})) :[] );
            setLoading(false);
        } catch (error) {
            console.log(error);
            setError("Houve algum erro ao carregar os dados!");
            setLoading(false);
        }
    },[url]);

    useEffect(()=>{
        fetchProducts();
    },[fetchProducts]);

    // #### ADICIONA ####
    const addProducts = async(product)=>{
        setLoading(true); // recebe false quando atualizar em fetchProducts
        try {
            await apiRequest(`${url}.json`, "POST", product);
            fetchProducts();
        } catch (error) {
            console.log(error);
            setError("Houve algum erro ao tentar adicionar o produto!");
        }
    };

    // #### REMOVE ####
    const deleteProduct = async(id)=>{        
        setLoading(true) // recebe false quando atualizar em fetchProducts
        try {
            await apiRequest(`${url}/${id}.json`, "DELETE");
            fetchProducts();
        } catch (error) {
            console.log(error);
            setError("Houve algum erro ao tentar remover o produto!");
        }
    };

    return {data, loading, error, addProducts, deleteProduct}
}